import script from "./InviteDialog.vue?vue&type=script&lang=ts&setup=true"
export * from "./InviteDialog.vue?vue&type=script&lang=ts&setup=true"

import "./InviteDialog.vue?vue&type=style&index=0&id=54958620&lang=scss"

const __exports__ = script;

export default __exports__